import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      const mountMarquees = () => {
        document.querySelectorAll( '[data-component="marquee"] .marquee__splide' ).forEach( ( element ) => {
          if ( element.dataset.marqueeMounted === 'true' ) {
            return;
          }

          const slideText = element.querySelector( '.marquee__slide-text' );
          if ( !slideText ) {
            return;
          }

          element.dataset.marqueeMounted = 'true';

          const slider = new Splide( element, {
            type: 'loop',
            drag: true,
            focus: 0,
            arrows: false,
            fixedWidth: `${Math.ceil( slideText.scrollWidth )}px`,
            pagination: false,
            autoScroll: {
              speed: 0.75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );

          slider.mount( {AutoScroll} );
        } );
      };

      if ( document.fonts?.ready ) {
        document.fonts.ready.then( mountMarquees );
      } else {
        mountMarquees();
      }
    },
    finalize: function() {},
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
